import { FormattedMessage } from 'react-intl';
import {
  Button,
  SubmitButton,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { SettingsIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import useGenerateWaitlistV2Report from './hooks.useGenerateWaitlistV2Report';
import ElementWithPermissions from '../../components/ElementWithPermissions';
import affordableWaitlistMessages from '../ManageAffordableWaitlist/messages';
import messages from './messages';

const ManageAffordableWaitlistV2Buttons = ({
  organizationId,
  propertyId,
  bedroomCount,
  disabled,
  openConfigurePreferences,
}) => {
  const { mutate: generateReport, isLoading: isReportLoading } =
    useGenerateWaitlistV2Report({
      organizationId,
      propertyId,
      bedroomCount,
    });

  return (
    <>
      <ElementWithPermissions
        scope={['affordable-waitlist-conigure-preferences']}
      >
        <Button
          variant={'primarySubtle'}
          startIcon={<SettingsIcon />}
          disabled={disabled}
          onClick={openConfigurePreferences}
          sx={{ height: 'fit-content' }}
        >
          <FormattedMessage
            {...affordableWaitlistMessages.configurePreferences}
          />
        </Button>
      </ElementWithPermissions>
      <SubmitButton
        variant={'shout'}
        disabled={disabled}
        sx={{ height: 'fit-content' }}
        onClick={generateReport}
        isSubmitting={isReportLoading}
      >
        <FormattedMessage {...messages.generateReport} />
      </SubmitButton>
    </>
  );
};

export default ManageAffordableWaitlistV2Buttons;
